import { z } from 'zod';

export const preferencesSchema = z.object({
  dismiss2024PricingAnnouncement: z.boolean().default(false),
  exportFormat: z
    .union([
      z.literal('react'),
      z.literal('html'),
      z.literal('webflow'),
      z.literal('figma'),
    ])
    .default('figma'),
});

export type Preferences = z.infer<typeof preferencesSchema>;

// Currently only string, boolean and number are supported but this could technically be any valid JSON object.
const updatePreferencesRequestSchema = z
  .union([z.string(), z.boolean(), z.number()])
  .nullable();

export type UpdatePreferencesRequest = z.infer<
  typeof updatePreferencesRequestSchema
>;
